import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BaseButtonSize, WorkCouncilStatus } from 'base';
import { BaseCustomerWorkCouncilStatusEnum } from '../../../_enums/base-customer-work-council-status.enum';

@Component({
  selector: 'base-customer-work-council-response-buttons',
  templateUrl: 'base-customer-work-council-status-buttons.component.html',
})
export class BaseCustomerWorkCouncilStatusButtonsComponent {
  @Input() workCouncilStatus?: WorkCouncilStatus;
  @Output() statusChange = new EventEmitter<BaseCustomerWorkCouncilStatusEnum>();

  baseButtonSize = BaseButtonSize;
  customerWorkCouncilStatus = BaseCustomerWorkCouncilStatusEnum;

  get hasApproveStatus() {
    return (
      this.workCouncilStatus === BaseCustomerWorkCouncilStatusEnum.APPROVED ||
      this.workCouncilStatus === BaseCustomerWorkCouncilStatusEnum.AUTO_APPROVED
    );
  }

  get hasDisapproveStatus() {
    return this.workCouncilStatus === BaseCustomerWorkCouncilStatusEnum.DISAPPROVED;
  }

  get hasNoteStatus() {
    return this.workCouncilStatus === BaseCustomerWorkCouncilStatusEnum.NOTED;
  }

  get approveButtonColor() {
    if (!this.workCouncilStatus || this.hasDisapproveStatus) {
      return 'dark';
    }

    if (this.hasNoteStatus) {
      return 'secondary';
    }

    return 'success';
  }

  get disapproveButtonColor() {
    if (this.hasDisapproveStatus) {
      return 'danger';
    }

    if (this.hasApproveStatus || this.hasNoteStatus) {
      return 'secondary';
    }

    return 'dark';
  }

  get noteButtonColor() {
    if (!this.workCouncilStatus || this.hasDisapproveStatus) {
      return 'dark';
    }

    if (this.hasApproveStatus) {
      return 'secondary';
    }

    return 'success';
  }

  handleStatusChange(event: MouseEvent, status: BaseCustomerWorkCouncilStatusEnum) {
    event.preventDefault();

    this.statusChange.emit(status);
  }
}
